<app-progress-bar></app-progress-bar>
<section class="main-login up-down">
  <!-- Contenedor imagen y formulario -->
  <div class="login-container">
    <!-- Contenedor formulario-->
    <div class="login-container__content">
      <div class="login-container__content__title">
        <h5>{{ translatedTextKeyLogin.WELLCOME_TITTLE | translate }}</h5>
      </div>
      <div class="login-container__content__form">
        <form [formGroup]="form" class="login-form">

       <div class="login-form__buttons--networks">
  <button
    *ngFor="let provider of providers"
    class="login-form-2__sing-in-others"
    (click)="getAuthCode(provider.name)"
    pButton
    type="button"
  >
    <img [src]="provider.iconPath" [alt]="provider.name" />

   @if(provider.name =='Google'){
    {{translatedTextKeyLogin.LOG_IN_GOOGLE | translate}}
   }@else{
 {{translatedTextKeyLogin.LOG_IN_MICROSOFT | translate}}
   }

  </button>
</div>

          <div class="login-form__inputs">
            <div class="login-form__inputs__field">
              <div class="form-field">
                <label>{{
                  translatedTextKeyLogin.EMAIL_ADDRESS | translate
                }}</label>
                <input
                  type="text"
                  formControlName="username"
                  class="form-field--user"
                  [ngClass]="{ 'input-error': form.get('username')?.invalid && (form.get('username')?.touched || form.get('username')?.dirty) }"
                />
              </div>
              <div
                class="text-danger"
                *ngIf="
                  form.get('username').errors &&
                  (form.get('username').dirty || form.get('username').touched)
                "
              >
                <ul>
                  <li *ngIf="form.get('username').errors?.['required']; ">
                    {{ translatedTextKeyLogin.EMAIL_REQUIRED | translate }}
                  </li>
                  <li *ngIf="form.get('username').errors?.['invalidEmail']; ">
                    {{ translatedTextKeyLogin.EMAIL_INVALID | translate }}
                  </li>
                </ul>
              </div>
            </div>

            <div class="login-form__inputs__field">
              <div class="form-field">
                <label>{{ translatedTextKeyLogin.PASSWORD | translate }}</label>
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  formControlName="password"
                  class="form-field--password"
                  [ngClass]="{ 'input-error': form.get('password')?.invalid && (form.get('password')?.touched || form.get('password')?.dirty) }"
                />
                <span class="form-field__show-pass" (click)="togglePassword()">
                  <img
                    src="./../../../../../assets/images/icons/show-password-icon.svg"
                    alt=""
                  />
                </span>
              </div>
              <div
                class="text-danger"
                *ngIf="
                  form.get('password').errors &&
                  (form.get('password').dirty || form.get('password').touched)
                "
              >
                <ul>
                  <li>
                    {{ translatedTextKeyLogin.PASSWORD_REQUIRED | translate }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="login-form__buttons">
            <a
              routerLink="password-recovery/"
              class="login-form__buttons__link login-form__buttons__link--password"
              >{{ translatedTextKeyLogin.FORGOT_PASSWORD | translate }}</a
            >
            @if(false){
              <p-skeleton width="100%" height="43px" />
            }
            @else {
              <button
                class="login-form__buttons__login-button p-button-success"
                (click)="onSubmit()"
                pButton
                type="submit"
              >
                {{ translatedTextKeyLogin.LOG_IN | translate }}
              </button>
            }
            <p class="login-form__buttons__text">
              <a
                href="javascript:void(0)"
                (click)="goRegisterForm()"
                class="login-form__buttons__link login-form__buttons__link--register"
                >{{ translatedTextKeyLogin.SIGN_IN | translate }}</a
              >
            </p>
          </div>
          @if(false){
            <p-skeleton width="100%" height="21px" />
          }          @else {
            <div class="login-form__country-flag">
              <span>{{ 'mcfLoginShell.login.youAreIn' | translate }} {{this._userService.storeConfig?.storeName}}</span>
              <img [src]="this._userService.storeConfig?.storeLogo" height="21" width="21" [alt]="this._userService.storeConfig?.storeName" />
            </div>
          }
        </form>
      </div>
    </div>
    <!-- Contenedor imagen-->
    <div class="login-container__image">
      <img
        [src]="backgroundImage"
        alt="Argos ONE 2G Image"
      />
    </div>
  </div>
  <!-- <div class="social-media">
    <p class="social-media__text">{{mcfLoginShell.signup.followUsSocial | translate}}</p>
    <ul class="social-media__networks">
      <li class="social-media__networks__item">
        <a href="#" target="_blank">
          <i class="icon-twitter"></i>
        </a>
      </li>
      <li class="social-media__networks__item">
        <a href="#" target="_blank">
          <i class="icon-facebook"></i>
        </a>
      </li>
      <li class="social-media__networks__item">
        <a href="#" target="_blank">
          <i class="icon-instagram"></i>
        </a>
      </li>
    </ul>
  </div> -->
</section>
<app-app-modal></app-app-modal>

